routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsDetail', {
      url: "/pqrs/detalle/{id}",
      template: `<pqrs-detail sh-ctrl="shCtrl"></pqrs-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pqrs/pqrs-detail/pqrs-detail.config.js
 **/